import type { LearnerClient, LearnerView } from "@tutor/live";
import { useCallback, useSyncExternalStore } from "react";

/**
 * The client's current view, re-rendering on every change. The client returns the same
 * object until something changes, which is what `useSyncExternalStore` requires.
 */
export function useLearnerView(client: LearnerClient): LearnerView {
  const subscribe = useCallback(
    (onChange: () => void) =>
      client.subscribe(() => {
        onChange();
      }),
    [client],
  );
  const getSnapshot = useCallback(() => client.getView(), [client]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
